import React, {useState} from 'react'
import './assess.css'
import { Container, Form,Card, Row, Col, Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const Menu = ({tests}) => {

    
   return (
    <Container fluid className='my-5'>
      {
        tests.map((testItem) =>{
            const{id, field, testImage, topics, review} = testItem;
            let keywords = [...topics];
            return(
              
                <Card className='test-card p-3 mb-4'style={{ background:'#F0F5FBB3'}}>
                  <Row className='align-items-center gap-4'>
                    <Col md={2} lg={2} xl={1}>
                    <img src={testImage}/>
                    </Col>
                    <Col className='d-flex flex-column gap-2 ps-2 '>
                    
                        <h4 className=''>{field}</h4>
                        <h5 classname='d-flex topics'> Topics: &nbsp;
                        {keywords.map((key,id) => (
                            <span key={id}>{key},  &nbsp;</span>
                            
                        ))} 
                        </h5>
                        <p>{review}</p>
                    
                    </Col>
                    <Col md={2} xl={5} className='justify-content-center align-items-center text-center'>
                    <Link to='/details' className='detail-btn text-decoration-none'>Details</Link>
                    </Col>
                  </Row>

                </Card>
            )
        })
      }
   
    </Container>
  )
}

export default Menu
